import {mergeDeepRight} from 'ramda';
import React from 'react';
import {
  Image,
  Pressable,
  ImageStyle,
  ViewStyle,
  ImageSourcePropType,
} from 'react-native';
import {colors} from 'theme/Colors';
import {spacing, corner_radius} from 'theme/Units';

type sizeTypes = 'lg' | 'md' | 'sm';
interface UIIconButtonProps {
  onPress?: () => void;
  icon?: ImageSourcePropType;
  iconSize?: number;
  size?: sizeTypes;
}

export const ActionIconButton: React.FC<UIIconButtonProps> = ({
  onPress,
  icon,
  iconSize = 14,
  size = 'md',
}) => {
  const styles = mergeDeepRight(baseStyles, sizeStyles[size]) as styleProps;
  const iconSizeStyle: ImageStyle = {
    width: iconSize,
    height: iconSize,
  };
  return (
    <Pressable style={styles.button} onPress={onPress}>
      {icon ? (
        <Image style={iconSizeStyle} resizeMode="contain" source={icon} />
      ) : null}
    </Pressable>
  );
};

type styleProps = {
  button: ViewStyle;
};

const baseStyles: styleProps = {
  button: {
    borderColor: colors.palette.stroke,
    borderWidth: 1,
    padding: spacing['2'],
    borderRadius: corner_radius['rounded-md'],
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing['2'],
    aspectRatio: '1/1',
  },
};

const sizeStyles: Record<sizeTypes, Partial<styleProps>> = {
  lg: {
    button: {
      height: 48,
      fontSize: 20,
    },
  },
  md: {
    button: {
      height: 40,
      fontSize: 18,
    },
  },
  sm: {
    button: {
      height: 32,
      fontSize: 14,
    },
  },
};
